import { Reducer } from "redux";
import { connectRouter, LocationChangeAction, LOCATION_CHANGE } from "connected-react-router";

import { History, Location } from "history";
import { getPath } from "@montana/helpers/location.helper";
import { IRouterContainerState } from "./router";
import { IPageAction, PageActionTypes } from "../page/page.actions";

const initialState: IRouterContainerState = {
    isRouting: false,
    isFirstRendering: true,
} as IRouterContainerState;

export function isSameRoute(prevLocation: Location, nextLocation: Location): boolean {
    const prevPath = getPath(prevLocation);
    const nextPath = getPath(nextLocation);

    return prevPath === nextPath;
}

export function createRouterReducer(history: History): Reducer<IRouterContainerState, LocationChangeAction | IPageAction> {
    const connectedRouterReducer = connectRouter(history);

    return (state, action): IRouterContainerState => {
        if (state === undefined) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return { ...initialState, ...connectedRouterReducer(state, action as any) };
        }

        const { ...connectedRouterState } = state || initialState;

        // As per redux convention, pass all actions through connected router.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nextState = { ...state, ...connectedRouterReducer(connectedRouterState, action as any) };

        switch (action.type) {
            case LOCATION_CHANGE: {
                if ((isSameRoute(state.location, action.payload.location) && state.location.hash === action.payload.location.hash) || action.payload.action === "REPLACE") {
                    return { ...state, isFirstRendering: !!action?.payload?.isFirstRendering };
                }

                if (action.payload.isFirstRendering) {
                    return nextState;
                }

                return { ...nextState, isRouting: true, isFirstRendering: false };
            }
            case PageActionTypes.FETCH_DATA_SUCCESS:
            case PageActionTypes.FETCH_DATA_ERROR: {
                return { ...nextState, isRouting: false };
            }
            default: {
                return nextState;
            }
        }
    };
}
